module.exports = __webpack_public_path__ + "img/qbpng.9d475fb0.png";